var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPenNib = function SvgIconPenNib(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.574 1.696a1.75 1.75 0 0 1 1.92.383l6.427 6.427a1.75 1.75 0 0 1 0 2.488l-2.31 2.31-2.023 5.39a1.74 1.74 0 0 1-1.342 1.117h-.004L3.177 21.984a1 1 0 0 1-.27.012.995.995 0 0 1-.904-.922 1 1 0 0 1 .013-.251l2.173-13.06a1.76 1.76 0 0 1 1.108-1.348l.005-.001 5.394-2.024 2.31-2.31a1.8 1.8 0 0 1 .568-.384M5.912 19.502l9.851-1.638 1.824-4.862-6.589-6.59-4.86 1.824-1.64 9.851 3.483-3.482a3.25 3.25 0 1 1 1.414 1.414zM20.336 9.75l-1.586 1.586-6.086-6.086 1.586-1.586zM9.625 13.125a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconPenNib;